import { createContext } from "react";

var _createContext = /*#__PURE__*/createContext(function () {}),
    Provider = _createContext.Provider,
    Consumer = _createContext.Consumer;

export { Provider, Consumer };